import React from 'react'
import {Route,Switch} from 'react-router'
//import APP from '../containers/APP'
import StartPage from '../containers/StartPage'
import QuizPage from '../containers/QuizPage'
// https://github.com/ReactTraining/react-router/blob/cfe934b582c0da42b3b12b8bc4ad90fcc86f0933/packages/react-router/docs/guides/migrating.md#switch
/* closed - 170525
export default (
    <Route path="/" component={APP}>
        <IndexRoute  
            component={StartPage} />    
        <Route path="quiz/:qnum"
            component={QuizPage} />
    </Route>
)
*/
const Routes =  () => (
    <Switch>
        <Route exact path='/' component={StartPage} />
        <Route path="/quiz/:qnum" component={QuizPage} />
    </Switch>
)
export default Routes;




// WEBPACK FOOTER //
// ./src/routes/routes.js